import React, { useState, useEffect } from "react";
import styles from "./Resource.module.scss";
import Header from "../../header/header";
import { FaEye, FaSortAmountDownAlt } from "react-icons/fa";
import { MdModeEdit, MdRestoreFromTrash, MdVisibility, MdCloudDownload } from "react-icons/md"; // Import view and download icons
import AddModal from "./addModal";
import EditModal from "./editModal";
import { toast } from "react-toastify";
import { db, storage } from "../../../firebase";
import { CustomSpinner } from "../../shared/Spinner";

export default function ResourcePage() {
  const [loading, setLoading] = useState(false);
  const [showAddModal, setShowAddModal] = useState(false);
  const [resourceData, setResourceData] = useState(null);
  const [editModelToggle, setEditModelToggle] = useState(null);

  useEffect(() => {
    getResourceData();
  }, []);

  const formatDate = (dateString) => {
    const [year, month, day] = dateString.split("-");
    return `${month}/${day}/${year}`;
  };

  const getResourceData = async () => {
    setLoading(true);
    try {
      const response = await db.collection("resources").get();
      const data = response.docs.map((doc) => {
        return { id: doc.id, ...doc.data() };
      });
      data.sort((a, b) => new Date(b.date) - new Date(a.date));
      setResourceData(data);
      setLoading(false);
    } catch (error) {
      console.log(error, "error");
      setLoading(false);
    }
  };

  const handleDeletePacket = async (id, pdfUrl) => {
    try {
      const confirmation = window.confirm("Are you sure you want to delete this resource?");
      if (confirmation) {
        await db.collection("resources").doc(id).delete();
        const storageRef = storage.refFromURL(pdfUrl);
        await storageRef.delete();
        toast.success("Resources deleted successfully");
        getResourceData();
      }
    } catch (error) {
      console.error("Error deleting resource: ", error);
      toast.error("Error deleting resource");
    }
  };

  if (loading) {
    return <CustomSpinner />;
  }

  if (!resourceData && !loading) {
    return <div>Loading resource data</div>;
  }

  return (
    <div className={styles.container}>
      <Header />
      <div className={styles.content}>
        <div className={styles.title}>
          <h4>Resource</h4>
          <p>This section is used to add PDF files for admin resources</p>
        </div>
        <hr />
        <div className={styles.table}>
          <div className={styles.tableHeader}>
            <div>
              <span>Total</span>
              <span>{resourceData ? resourceData.length : "0"}</span>
            </div>
            <button onClick={() => setShowAddModal(true)}>Add Resources</button>
          </div>
          <div className={styles.row}>
            <div>Resources</div>
            <div>Type</div>
            <div>Date</div>
            <div>Actions</div>
          </div>
          {resourceData.map((item) => (
            <div key={item.id} className={styles.row}>
              <div>{item.title}</div>
              <div>{item.type}</div>
              <div>{formatDate(item.date)}</div>
              <div>
                <a
                  href={item.pdfUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <FaEye style={{ color: "grey", marginRight: "5px" }} />
                </a>
                <MdModeEdit
                  onClick={() => setEditModelToggle(item)}
                  style={{ color: "green", marginRight: "5px" }}
                />
                <MdRestoreFromTrash
                  style={{ color: "red", marginRight: "5px" }} // Add spacing
                  onClick={() => handleDeletePacket(item.id, item.pdfUrl)}
                />
              </div>
            </div>
          ))}
        </div>
      </div>

      {showAddModal && (
        <AddModal setOpen={setShowAddModal} reloadData={getResourceData} />
      )}

      {editModelToggle && (
        <EditModal
          data={editModelToggle}
          setOpen={setEditModelToggle}
          reloadData={getResourceData}
        />
      )}
    </div>
  );
}
